var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"click":_vm.onCLickBody}},[_c('Menu'),_c('Accueil'),_c('Histoire'),_c('Services'),_c('Livraison'),_c('Contact'),_c('ConsentCookie')],1)}
var staticRenderFns = []

export { render, staticRenderFns }